export default __webpack_public_path__ + "static/media/addMemberIcon.1feba714.svg";